import React, { Component } from 'react'
import {Row,Col, Form, Button,Modal} from 'react-bootstrap';
import classes from './modeofinterview.module.css'
import {connect} from 'react-redux';
export class Modeofinterview extends Component {
    state={
      checkedvalue:null,
      errorMsg:null,
    }
  selectModeofInterview=(e)=>{
    var checkboxes = e.target.value;
    this.setState({errorMsg:null,checkedvalue:checkboxes});
      //this.state.checkedvalue=checkboxes;
}
proceed=()=>{
  if(this.state.checkedvalue!==null){
    this.props.selectModeofInterview(this.state.checkedvalue)
  }
  else{
    this.setState({errorMsg:"Please select an option"});
  }
}
closeAndReset=()=>{
  this.state.checkedvalue=null;
  this.state.errorMsg=null;
  this.props.openModeofinterview("mode");

}

    render() {
     
        return (
          <>
          <Modal centered show={this.props.show} >
          <Modal.Header>
              <Modal.Title style={{textAlign: 'center'}} id="contained-modal-title-vcenter">
              Please select a mode
              </Modal.Title>
            </Modal.Header>
        <Modal.Body>
        <Row>
             
             <Col lg={12}>
               <div className={classes.selectradio}>
                 {this.props.telephonic?
               <label className={classes.profilePopUp}>
               <input type="radio" name="gender" onChange={this.selectModeofInterview.bind(this)} value="Telephonic"/> &nbsp; &nbsp;Telephonic
              <span className={classes.checkmark}></span>
             </label>
             :null}
             &nbsp; &nbsp;
             {this.props.vedio?
             <label className={classes.profilePopUp}>
               <input type="radio" name="gender" onChange={this.selectModeofInterview.bind(this)} value="Video" /> &nbsp; &nbsp;Video
              <span className={classes.checkmark}></span>
             </label>
             :null}
             &nbsp; &nbsp;
             {this.props.faceToFace?
             <label className={classes.profilePopUp}>
               <input type="radio" name="gender" onChange={this.selectModeofInterview.bind(this)} value="Face to Face" /> &nbsp; &nbsp;Face to Face
              <span className={classes.checkmark}></span>
             </label>
            :null}
           </div>
           </Col>
           </Row>
           <Row>
             <Col lg={12} style={{textAlign:"center",color:"red"}}>
               {this.state.errorMsg!==null?this.state.errorMsg:null}
               </Col>
             </Row>
        </Modal.Body>
        <Modal.Footer className={classes.selectradio}>
         
            <Button onClick={()=>this.closeAndReset()} variant = "warning" className={classes.closeandproceddbutton}>Close</Button>
              <Button  variant = "warning" onClick={()=>this.proceed()} className={classes.closeandproceddbutton}>Proceed</Button>
       
        </Modal.Footer>
      </Modal>
          </>
        )
    }
}
const mapStateToProps = state => {
  return {
      telephonic:state.employeeReducer.telephonic,
      vedio:state.employeeReducer.vedio,
      faceToFace:state.employeeReducer.faceToFace,
      
  }
}
export default connect(mapStateToProps,null)(Modeofinterview);
